import React from 'react';
import BoldTemplate from '../templates/BoldTemplate';
import CleanTemplate from '../templates/CleanTemplate';
import CreativeTemplate from '../templates/CreativeTemplate';
import PopTemplate from '../templates/PopTemplate';

function TemplateRenderer({
  theme,
  liveProfileData,
  basicUser,
  isOwnProfile,
  onEdit,
  onTextClick,
  onColorClick,
  onPhotoClick,
  galleryEditMode,
  onToggleGalleryEdit,
  onGalleryConfigChange,
  onGalleryReorder,
  galleryConfig,
  onGalleryPhotoCrop,
  hiddenSections,
  onToggleSection,
  professions,
}) {
  const commonProps = {
    profileData: liveProfileData,
    basicUser,
    isOwnProfile,
    onEdit,
    onTextClick: isOwnProfile ? onTextClick : undefined,
    onColorClick: isOwnProfile ? onColorClick : undefined,
    onPhotoClick: isOwnProfile ? onPhotoClick : undefined,
    galleryEditMode,
    onToggleGalleryEdit: isOwnProfile ? onToggleGalleryEdit : undefined,
    onGalleryConfigChange: isOwnProfile ? onGalleryConfigChange : undefined,
    onGalleryReorder: isOwnProfile ? onGalleryReorder : undefined,
    galleryConfig,
    onGalleryPhotoCrop: isOwnProfile ? onGalleryPhotoCrop : undefined,
    hiddenSections,
    onToggleSection: isOwnProfile ? onToggleSection : undefined,
  };

  if (theme === 'bold') {
    return <BoldTemplate {...commonProps} />;
  }
  if (theme === 'clean') {
    return <CleanTemplate {...commonProps} />;
  }
  if (theme === 'creative') {
    return <CreativeTemplate {...commonProps} />;
  }
  if (theme === 'pop') {
    return <PopTemplate {...commonProps} professions={professions} />;
  }

  return null;
}

export default TemplateRenderer;
